import type { Property } from '~/core/entities/property';
import type { SectionName } from '~/types/mixpanel';
import type { ComputedRef, Ref } from 'vue';

import { inject, provide } from 'vue';

export type PropertyContext = {
	property: Ref<Property | null>;
	isLoading: Ref<boolean> | ComputedRef<boolean>;
	sectionName?: Ref<SectionName>;
	isContactModalOpen?: Ref<boolean>;
};

const PROPERTY_CONTEXT_KEY = Symbol('propertyContext');

export function providePropertyContext(context: PropertyContext) {
	provide(PROPERTY_CONTEXT_KEY, context);
}

export function usePropertyContext() {
	const context = inject<PropertyContext>(PROPERTY_CONTEXT_KEY);

	if (!context) {
		throw new Error(
			'usePropertyContext must be used within a PropertyContextProvider'
		);
	}

	return context;
}
